// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","socialBelongingContainer":"Gbcfb30"};